const languageMapper = {
  en: 'en_US',
  ko: 'ko_KR',
};

const localizationMapper = {
  en: {
    locale: 'en-US',
    localeName: 'English',
    currency: 'USD',
    currencyCode: '$',
    countryCode: 'US',
    countryName: 'United States',
    countries: ['US'],
  },
  ko: { 
    locale: 'ko-KR', 
    localeName: 'Korean',
    currency: 'KRW',
    currencyCode: '₩',
    countryCode: 'KR',
    countryName: 'South Korea',
    countries: ['KR'],
  },
};

const locales = Object.keys(localizationMapper);
const defaultLocale = locales[0];

const i18nConfig = { locales, defaultLocale };

const mapLanguage = (lang) => {
  if (!languageMapper[lang]) {
    console.error(`Language mapper is missing language ${lang}`);
  }

  //If language is not defined in languageMapper then select first locale
  return languageMapper[lang] || languageMapper[Object.keys(languageMapper)[0]];
};

const getLocalizationInfo = (locale) => {
  if (!(locale in localizationMapper)) {
    console.warn(
      `Invalid locale ${locale} provided. Possible values are ${Object.keys(localizationMapper).join(', ')}`,
    );

    return localizationMapper[defaultLocale];
  }

  return localizationMapper[locale];
};

module.exports = { languageMapper, mapLanguage, i18nConfig, getLocalizationInfo };
